import { CLEARED_COOPERATIVA_BY_COD_ACTION } from "../ContratosActions";
import { Action, AllContratosState, ModalUploadValoresCampos } from "./__types";
import { SET_CURRENT_CONTRATO_STEP, PREVIOUS_STEP_CONTRATOS, NEXT_STEP_CONTRATOS, ADD_SINGLE_FILE_CONTRACT_ACTION, CLEAR_UPLOADED_FILE_ACTION, SET_FILTERS_DOCUMENTO, RESET_FILTERS_DOCUMENTO, LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION, LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION, RECOVER_FILTERS_DOCUMENTO, RECOVER_FILTERS_DOCUMENTO_ENTE_PUBLICO, ADD_SELECTED_OPTION_ACTION, CLEAR_SELECTED_OPTION_ACTION, LOADED_ADENDO_ACTION, LIST_ADENDOS_ACTION, CLEAR_CONTRATO_ADENDOS, LOADED_CONTRATO_STATUS_CONTRATO_GLOBAL, CLEAR_CONTRATO_STATUS_GLOBAL, RECOVER_FILTERS_DOCUMENTO_ENTE_PRIVADO, ADD_MULTIPLES_FILES_CONTRACT_ACTION, REMOVE_MULTIPLES_FILES_CONTRACT_ACTION, REMOVE_MULTIPLES_ALL_FILES_CONTRACT_ACTION, SET_DOCUMENTOS_CONTRACT, OPEN_MODAL_UPLOAD_DOCUMENTOS, CLOSE_MODAL_UPLOAD_DOCUMENTOS, OPEN_MODAL_UPLOAD_DOCUMENTOS_COM_PARAMETROS } from './AllContratosActions'


const COOPERATIVA_BY_COD_INITIAL_STATE = {
  complemento: '',
  cnpj: '',
  nomeFantasia: '',
  codigoEntidade: '',
  endereco: '',
  numero: '',
  bairro: '',
  municipio: '',
  uf: '',
  cep: '',
  tipoEndereco: '',
  email: '',
};

const ADENDO_EDITING_INITIAL_STATE = {
  id: null,
  flgStatus: 0,
  versaoContrato: 1,
  codigo: '',
  ativo: false,
  idDocAssinado: null,
  idDocNaoAssinado: null,
  idDocExtrato: null,
  idDocPlanoTrabalho: null,
  extensaoDocAssinado: null,
  extensaoDocNaoAssinado: null,
  extensaoDocExtrato: null,
  extensaoDocPlanoTrabalho: null,
  dataAlteracao: '',
  incluiPlanoTrabalho: false,
  permiteExclusao: false
};

const ADENDO = {
  adendos: [ADENDO_EDITING_INITIAL_STATE],
  flgStatus: 0,
  geraAditivo: false,
  geraDistrato: false,
  idContrato: null,
};

const INITIAL_STATE: AllContratosState = {
  currentContratoStep: 0,
  uploadSingleFile: null,
  uploadSelectedOption: [],
  adendoEditing: ADENDO_EDITING_INITIAL_STATE,
  adendoObject: ADENDO,
  adendosAll: [],
  cooperativaByCod: COOPERATIVA_BY_COD_INITIAL_STATE,
  loadingCooperativaByCod: false,
  loadingArquivosAuxiliaresList: false,
  arquivosAuxiliaresList: [],
  filterDocumentos: {
    tipoFluxo: null,
    tipoContrato: null,
    programa: [],
  },
  statusDefinitivo: 0,
  uploadMultiplosArquivos: [] as File[],
  documentos: [],
  modalUploadDocumentos: false,
  modaUploadValoresCampos: {} as ModalUploadValoresCampos
};

export default function AllcontratosReducer(state: AllContratosState = INITIAL_STATE, action: Action): AllContratosState {
  switch (action.type) {
    case SET_CURRENT_CONTRATO_STEP:
      return { ...state, currentContratoStep: action.payload };
    case NEXT_STEP_CONTRATOS:
      return {
        ...state,
        currentContratoStep: Math.min(state.currentContratoStep + 1, 3),
      };
    case PREVIOUS_STEP_CONTRATOS:
      return {
        ...state,
        currentContratoStep: Math.max(state.currentContratoStep - 1, 0),
      };
    case LOADED_ADENDO_ACTION:
      return {
        ...state,
        adendoEditing: {
          ...ADENDO_EDITING_INITIAL_STATE,
          ...action.payload,
        },
        adendoObject: {
          ...ADENDO,
          ...action.payload,
        },
      };
    case LIST_ADENDOS_ACTION:
      return {
        ...state,
        adendosAll: action.payload.adendos || [],
      };
    case LOADED_CONTRATO_STATUS_CONTRATO_GLOBAL:
      return {
        ...state,
        statusDefinitivo: action.payload,
      };
    case CLEAR_CONTRATO_STATUS_GLOBAL:
      return {
        ...state,
        statusDefinitivo: INITIAL_STATE.statusDefinitivo,
      };
    case CLEAR_CONTRATO_ADENDOS:
      return {
        ...state,
        adendosAll: [],
        statusDefinitivo: INITIAL_STATE.statusDefinitivo,
      };
    case ADD_SINGLE_FILE_CONTRACT_ACTION:
      return {
        ...state,
        uploadSingleFile: action.payload,
      };
    case ADD_SELECTED_OPTION_ACTION:
      return {
        ...state,
        uploadSelectedOption: action.payload,
      };
    case CLEAR_UPLOADED_FILE_ACTION:
      return {
        ...state,
        uploadSingleFile: null,
      };
    case CLEAR_SELECTED_OPTION_ACTION:
      return {
        ...state,
        uploadSelectedOption: [],
      };
    case SET_FILTERS_DOCUMENTO:
    case RECOVER_FILTERS_DOCUMENTO:
    case RECOVER_FILTERS_DOCUMENTO_ENTE_PUBLICO:
    case RECOVER_FILTERS_DOCUMENTO_ENTE_PRIVADO:
      return {
        ...state,
        filterDocumentos: {
          ...state.filterDocumentos,
          ...action.payload,
        }
      };
    case CLEARED_COOPERATIVA_BY_COD_ACTION:
      return { ...state, cooperativaByCod: COOPERATIVA_BY_COD_INITIAL_STATE };
    case RESET_FILTERS_DOCUMENTO:
      return {
        ...state,
        filterDocumentos: INITIAL_STATE.filterDocumentos,
      };
    case LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION:
      return { ...state, loadingArquivosAuxiliaresList: action.payload };
    case LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION:
      return { ...state, arquivosAuxiliaresList: action.payload };

    case ADD_MULTIPLES_FILES_CONTRACT_ACTION:
      return {
        ...state,
        uploadMultiplosArquivos: [...state.uploadMultiplosArquivos, ...action.payload],
      };
    case REMOVE_MULTIPLES_FILES_CONTRACT_ACTION:
      return {
        ...state,
        uploadMultiplosArquivos: state.uploadMultiplosArquivos.filter(file => file !== action.payload),
      };
    case REMOVE_MULTIPLES_ALL_FILES_CONTRACT_ACTION:
      return {
        ...state,
        uploadMultiplosArquivos: []
      }
    case SET_DOCUMENTOS_CONTRACT:
      return {
        ...state,
        documentos: action.payload,
      };
    case CLOSE_MODAL_UPLOAD_DOCUMENTOS:
      return {
        ...state,
        modalUploadDocumentos: false,
      };
    case OPEN_MODAL_UPLOAD_DOCUMENTOS:
      return {
        ...state,
        modalUploadDocumentos: true,
      };
    case OPEN_MODAL_UPLOAD_DOCUMENTOS_COM_PARAMETROS:
      return {
        ...state,
        modaUploadValoresCampos: action.payload,
        modalUploadDocumentos: true,
      };
    default:
      return state;
  }
}